<template>
  <div>
    <div
      class="parent"
      :style="style"
      :class="[!showDetails ? 'parent-2' : '']"
    >
      <v-card @click="showCoursefun">
        <v-card-title class="info-title">
          <font-awesome-icon
            v-if="!showDetails"
            class="collapse"
            icon="angle-left"
          />
          <div class="text-center text-padding">
            {{ exam.Name }}
          </div>
        </v-card-title>
        <div>
          <app-row icon="university" title="شناسه دوره:" :value="exam.ID" />
          <app-row
            v-if="showDetails"
            icon="calendar-alt"
            title="بازه پرینت کارت:"
            :value="exam.PrintRange"
          />
          <app-row
            icon="download"
            title="دریافت کارت ورود به جلسه:"
            :showButton="true"
            buttonText="دانلود"
            @clicked="$emit('download', exam.ID)"
            v-if="showDetails"
          />
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";

export default {
  props: ["exam", "index", "selectedCourse", "showDetails"],
  components: {
    appRow: DetailRow,
  },
  /**
   * show cycle exams
   */
  methods: {
    showCoursefun() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
  },
  computed: {
    style() {
      var res = "";
      if (this.showDetails) {
        res += "position: fixed;";
        if (this.$store.getters.isMobile) {
          res += "width: 100%;background-color: rgb(232,232,232) !important;";
        } else {
          res += "width: calc(100% - 300px)";
        }
      }
      return res;
    },
  },
};
</script>
<style>
.vpd-input-group {
  z-index: 5 !important;
}
</style>
